import React from 'react';
import {Autocomplete, AutocompleteProps, TextField} from "@mui/material";
import {useAutocompleteOptions} from "../../../../hooks/autocomplete/useAutocompleteOptions";
import EquipmentTypes from "../../../EquipmentTypes";

const options = [
  {label: "All", id: ""},
  ...EquipmentTypes.OPTIONS.map(name => ({label: name, id: name}))
];

interface EquipmentTypeAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
}

const EquipmentTypeAutocomplete = (props: EquipmentTypeAutocompleteProps) => {

  const renderInput = (params: any) => (
    <TextField {...params} label={'Equipment Type'} variant={'standard'} />
  )

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
  } = useAutocompleteOptions({ autocompleteOptions: options })

  return (
    options?.length > 1 && <Autocomplete
      disablePortal
      disableClearable
      renderInput={renderInput}
      options={options}
      getOptionLabel={handleGetOptionLabel}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      {...props}
    />
  )
}

export { EquipmentTypeAutocomplete };
